declare const window:any;
export const fieldSortFunc = function(fieldArray:any,sortField:string,pageParamsData:{}){
    /******************循环查找是否按照指定字段进行输出 start**************************** */
    let sortN:number = 0;
    let maxOrder:number = 0;
    let minOrder:number = 0;
    let isSort:boolean = false;
    for(let fieldI=0; fieldI<fieldArray.length; fieldI++){
        let fieldData:any = fieldArray[fieldI];
        if(typeof(fieldData[sortField])=='number'){
            if(fieldData[sortField] > maxOrder){
                maxOrder = fieldData[sortField];//找到最大的排序值
            }
            if(fieldData[sortField] < minOrder){
                minOrder = fieldData[sortField];//找到最小的排序值
            }
            sortN++;
        }
    }
    /************************页面入参的key和当前表格列支持查询的key有重复 start *****/
    if(!window.jQuery.isEmptyObject(pageParamsData)){
        for(let c=0; c<fieldArray.length; c++){
            const cObj = typeof(fieldArray[c])=='object' ? fieldArray[c] : {};
            const cEditConfig = typeof(cObj.editConfig)=='object' ? cObj.editConfig : {};
            const tempKeyFieldStr = cEditConfig.id ? cEditConfig.id : cObj.field;
            if(pageParamsData[tempKeyFieldStr]){
                cEditConfig.value = pageParamsData[tempKeyFieldStr];
                delete cEditConfig.valueExpression;//此参数存在于当前来源参数中 以当前为准 删除来源参
                minOrder = minOrder --;
                cObj.queryOrder = minOrder;
            }
        }
    }
    /************************页面入参的key和当前表格列支持查询的key有重复 end *****/
    if(sortN == fieldArray.length){
        isSort = true;//全部都配置了排序字段
    }else{
        if(sortN > 0){
            isSort = true;//没有都配置排序字段 找到没有设置的，给默认值（最大值累加）
            for(let fieldI=0; fieldI<fieldArray.length; fieldI++){
                let fieldData:any = fieldArray[fieldI];
                if(typeof(fieldData[sortField])=='undefined'){
                    maxOrder++; 
                    fieldData[sortField] = maxOrder;
                }
            }
        }
    }
    if(isSort === true){
        fieldArray.sort(function(obj1:any,obj2:any){return obj1[sortField] - obj2[sortField]});//排序
    }
    /******************循环查找是否按照指定字段进行输出 start**************************** */
}